import { environment } from '@environments/environment';

export const WIDGET_TYPE = {
  LEAD_GENERATOR: 1,
  SURVEY: 2,
  BOOKING: 3,
  // FILL_CALENDAR: 4,
};

export const TRIGGER_TYPE = {
  IMMEDIATELY: 1
};

export const BOTTOM_TYPES = {
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
};

export const CUSTOM_FIELD_TYPES = {
  CUSTOM_FIELD_SELECT: 'select',
  CUSTOM_FIELD_TEXT: 'text',
  CUSTOM_FIELD_TEXT_AREA: 'textarea',
  CUSTOM_FIELD_CHECKBOX: 'checkbox',
  CUSTOM_FIELD_FILE: 'file',
  CUSTOM_FIELD_RADIO: 'radio',
  CUSTOM_FIELD_DATE: 'date',
  CUSTOM_FIELD_INFORMATION: 'information',
  CUSTOM_FIELD_NUMBER_SELECT_CARD: 'number-select',
  CUSTOM_FIELD_IMAGE_SELECT_CARD: 'image-select',
  CUSTOM_FIELD_SELECT_CARD: 'card-select',
  CUSTOM_FIELD_WORKER_SELECT: 'worker-select',
  CUSTOM_FIELD_STORE_SELECT: 'store-select',
};

export const BOOKING_PAGE_VIEWS = {
  STORE_VIEW: 'STORE_VIEW',
  MEETING_TYPE_VIEW: 'MEETING_TYPE_VIEW',
  SERVICES_VIEW: 'SERVICES_VIEW',
  WORKERS_VIEW: 'WORKERS_VIEW',
  SLOTS_VIEW: 'SLOTS_VIEW',
  PERSONAL_FORM_VIEW: 'PERSONAL_FORM_VIEW',
  BOOKING_SUMMARY_VIEW: 'BOOKING_SUMMARY_VIEW',
  BOOKING_SUCCESS_VIEW: 'BOOKING_SUCCESS_VIEW',
  BOOKING_FAILED_VIEW: 'BOOKING_FAILED_VIEW',
  BOOKING_QUESTIONS_VIEW_BEFORE: 'BOOKING_QUESTIONS_VIEW_BEFORE',
  BOOKING_QUESTIONS_VIEW_AFTER: 'BOOKING_QUESTIONS_VIEW_AFTER'
} as const;

// [hidden_booking_steps / JB-1236] The ONLY booking steps that support being hidden via
// context.hidden_booking_steps. Each has force-skip + transient-flash suppression + a safety
// fallback wired up: MEETING_TYPE ← context.meeting_providers[0] when exactly one provider is
// configured, STORE ← context.store_id, SERVICES ← the answer's single supported service,
// WORKERS ← 0/Anyone. Any other BOOKING_PAGE_VIEWS key is intentionally NOT hideable (it has no
// resolver), so isStepHidden() and the query-param validation whitelist against this list.
// Listed in flow (precedence) order.
export const HIDEABLE_BOOKING_STEPS: string[] = [
  BOOKING_PAGE_VIEWS.MEETING_TYPE_VIEW,
  BOOKING_PAGE_VIEWS.STORE_VIEW,
  BOOKING_PAGE_VIEWS.SERVICES_VIEW,
  BOOKING_PAGE_VIEWS.WORKERS_VIEW
];

export const SALUTATION_TYPES = [
  { display: 'mr', value: 'm' },
  { display: 'ms', value: 'f' },
  { display: 'other', value: 'o' }
];

export const WIDGET_TEMPLATES_CONST = {
  WIDGET_BOOKING_INFO_APPOINTMENT: 'widget_booking_info_appointment',
  WIDGET_BOOKING_INFO_EVENT: 'widget_booking_info_event',
  WIDGET_NEXT: 'widget_next_button',
  WIDGET_PREVIOUS: 'widget_previous_button',
  WIDGET_BOOK_BUTTON: 'widget_book_button',
  WIDGET_APPOINTMENT_STORE_LABEL: 'widget_store_label',
  WIDGET_APPOINTMENT_SERVICE_LABEL: 'widget_choose_appointment_service_label',
  ADDITIONAL_SERVICES_BY_ANOTHER_MEETING_PROVIDER: 'additional_services_by_another_meeting_provider',
  WIDGET_DATE_LABEL: 'widget_choose_desired_date_label',
  WIDGET_NAV_SERVICE_LABEL: 'widget_navigation_selection_label',
  WIDGET_NAV_RESOURCE_LABEL: 'widget_navigation_resource_label',
  WIDGET_NAV_DATE_LABEL: 'widget_navigation_date_label',
  WIDGET_NAV_SUMMARY_LABEL: 'widget_navigation_summary_label',
  WIDGET_MORNING_LABEL: 'widget_morning_label',
  WIDGET_FORENOON_LABEL: 'widget_forenoon_label',
  WIDGET_NOON_LABEL: 'widget_noon_label',
  WIDGET_AFTERNOON_LABEL: 'widget_afternoon_label',
  WIDGET_EVENING_LABEL: 'widget_evening_label',
  WIDGET_NIGHT_LABEL: 'widget_night_label',
  WIDGET_RESOURCE_LABEL: 'widget_resource_label',
  WIDGET_ANYONE_LABEL: 'widget_anyone_label',
  WIDGET_ANYONE_DESC_LABEL: 'widget_anyone_description_label',
  WIDGET_NO_BOOKABLE_DATES_LABEL: 'widget_no_appointents_found',
  WIDGET_YES_SEARCH_BUTTON_LABEL: 'widget_no_appointents_found_button',
  WIDGET_IN_STORE_LABEL: 'widget_in_store_label',
  WIDGET_ANY_STORES: 'widget_any_stores',
  WIDGET_APPOINTMENT_SUCCESS_TITLE: 'widget_success_page_header_text',
  REDIRECTION_BUTTON_TEMPLATE: 'redirect_after_booking_action_button_text',
  WIDGET_MANAGE_BOOKING_LABEL: 'widget_manage_booking_label',
  WIDGET_DOWNLOAD_APPOINTMENT_ICS_FILE: 'widget_download_appointment_ics_file'
};

export const GTM_EVENTS = {
  // appointment
  appointment_booking_start: 'appointment_booking_start',
  appointment_booking_step_questions_start: 'appointment_booking_step_questions_start',
  appointment_booking_step_questions_end: 'appointment_booking_step_questions_end',
  appointment_booking_step_meetings_start: 'appointment_booking_step_meetings_start',
  appointment_booking_step_meetings_end: 'appointment_booking_step_meetings_end',
  appointment_booking_step_stores_start: 'appointment_booking_step_stores_start',
  appointment_booking_step_stores_end: 'appointment_booking_step_stores_end',
  appointment_booking_step_services_start: 'appointment_booking_step_services_start',
  appointment_booking_step_services_end: 'appointment_booking_step_services_end',
  appointment_booking_step_resources_start: 'appointment_booking_step_resources_start',
  appointment_booking_step_resources_end: 'appointment_booking_step_resources_end',
  appointment_booking_step_available_appointments_start: 'appointment_booking_step_available_appointments_start',
  appointment_booking_step_available_appointments_end: 'appointment_booking_step_available_appointments_end',
  appointment_booking_step_personal_data_start: 'appointment_booking_step_personal_data_start',
  appointment_booking_step_personal_data_end: 'appointment_booking_step_personal_data_end',
  appointment_booking_step_summary: 'appointment_booking_step_summary',
  appointment_booking: 'appointment_booking',
  appointment_booking_step_success: 'appointment_booking_step_success',
  appointment_booking_step_failed: 'appointment_booking_step_failed',

  // survey
  survey_start_step: 'survey_start_step',
  other_survey_steps: 'survey_step_',
  survey_last_step: 'survey_last_step',
};

export const EMAIL_REGEX =
  /^[\p{L}0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[\p{L}0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[_\p{L}0-9][-_\p{L}0-9]*\.)*(?:[\p{L}0-9][-\p{L}0-9]{0,62})\.(?:(?:[a-z]{2}\.)?[a-z]{2,})$/iu;
export const ZIP_REGEX = /^(?=.*\d)[A-Za-z0-9][A-Za-z0-9\s-]{1,9}$/;

/**
 * Sentinel persisted as `locale` by the dashboard's Language/Locale dropdown ("Browser language",
 * JB-1634) to mean "detect the visitor's language at runtime" instead of pinning one.
 *
 * It is a CONFIGURATION value only and must never reach the UI or an API payload: it is resolved
 * to a real Calenso locale — and written back onto `widgetConf.locale` — at the single point in
 * AppComponent.setupWidgetLang(). Downstream consumers (translations, the booking payload's
 * user_browser_language / user_selected_language) therefore only ever see a real locale.
 */
export const BROWSER_LOCALE_SENTINEL = 'browser';

export const LANGUAGES = [
  {
    text: 'german',
    value: 'de',
    secondary_text: 'DE',
    locale: 'de_CH',
    flagIcon: '/assets/images/flags/if_Flag_of_Switzerland_-_Circle.png',
  },
  {
    text: 'french',
    value: 'fr',
    secondary_text: 'FR',
    locale: 'fr_CH',
    flagIcon: '/assets/images/flags/if_Flag_of_France_-_Circle.png',
  },
  {
    text: 'italian',
    value: 'it',
    secondary_text: 'IT',
    locale: 'it_CH',
    flagIcon: '/assets/images/flags/if_Flag_of_Italy_-_Circle.png',
  },
  {
    text: 'english',
    value: 'en',
    secondary_text: 'EN',
    locale: 'en_US',
    flagIcon: '/assets/images/flags/if_Flag_of_United_States_-_Circle.png',
  },
  {
    text: 'dutch',
    value: 'nl',
    secondary_text: 'NL',
    locale: 'nl_NL',
    flagIcon: '/assets/images/flags/dutch.png',
  },
  {
    text: 'finnish',
    value: 'fi',
    secondary_text: 'FI',
    locale: 'fi_FI',
    flagIcon: '/assets/images/flags/finnish.png',
  },
  {
    text: 'polish',
    value: 'pl',
    secondary_text: 'PL',
    locale: 'pl_PL',
    flagIcon: '/assets/images/flags/polish.png',
  },
  {
    text: 'spanish',
    value: 'es',
    secondary_text: 'ES',
    locale: 'es_ES',
    flagIcon: '/assets/images/flags/spanish.png',
  },
  {
    text: 'swedish',
    value: 'sv',
    secondary_text: 'SE',
    locale: 'sv_SE',
    flagIcon: '/assets/images/flags/swedish.png',
  },
];

export const CUSTOMER_CSTM_FIELD_TITLE_LIST = [
  { id: 0, name: '--' },
  { id: 1, name: 'Dr.' },
  { id: 2, name: 'Dr. med.' },
  { id: 3, name: 'Prof.' },
  { id: 4, name: 'Prof. Dr.' }
];

export const WORKERS_VIEW = {
  CARD: "card",
  DROPDOWN: "dropdown"
};

export const WORKER_ATTRIBUTE_TYPES = {
  SELECT: 'select',
  TOOGLE: 'toggle'
};

export const PREFERRED_COUNTRIES = ['ch', 'de', 'fr', 'gb', 'it', 'nl', 'fi', 'pl', 'es', 'se', 'at'];

export const MIME_TYPES = {
  IMAGE: 'image/jpeg,image/jpe,image/png,image/gif',
  DOC: 'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

export const MEETING_TYPE_ID = {
  STORE: 1,
  ZOOM: 2,
  PHONE: 4,
  CUSTOMER: 5,
  UNBLU: 6,
  MICROSOFT_TEAMS: 7,
  GOOGLE_MEET: 8,
  GOTO_MEETING: 9,
  WEBEX: 10,
  WILL_CALL_YOU: 11,
  GROUP_APPOINTMENT_PLACE: 12,
  METAVERSE: 13,
  KMEET: 15
};

export const CALENSO_SCROLL_EVENT = 'calenso_scroll_to';

export const INTL_TEL_INPUT = {
  // Backend-proxied geo lookup — keeps the upstream provider token off the public bundle
  IPLOOKUP_URL: `${environment.restAPI}geo/lookup`
};

export const SECTION_PRECEDENCE = {
  BOOKING_QUESTIONS_VIEW_BEFORE: 1,
  MEETING_TYPE_VIEW: 2,
  STORE_VIEW: 3,
  SERVICES_VIEW: 4,
  WORKERS_VIEW: 5,
  SLOTS_VIEW: 6,
  BOOKING_QUESTIONS_VIEW_AFTER: 7,
  PERSONAL_FORM_VIEW: 8,
  BOOKING_SUMMARY_VIEW: 9,
  BOOKING_SUCCESS_VIEW: 10,
  BOOKING_FAILED_VIEW: 11
};

export const PAYMENT_TYPES = {
  PAYPAL: 'paypal',
  SAFERPAY: 'saferpay',
  ADYEN: 'adyen',
  STORE: 'store',
  INVOICE: 'invoice',
  CREDITCARD: 'creditcard',
  LEX_OFFICE_INVOICE: 'lex_office_invoice',
  // standalone invoice mode: no Bexio/lexOffice, the partner invoices from the webhook
  EXTERNAL_INVOICE: 'external_invoice'
};

export const BOOKING_REDIRECTION_VIEWS = {
  BOOKING_SUMMARY_VIEW: 'booking_summary_view',
  BOOKING_SUCCESS_VIEW: 'booking_success_view',
} as const;

export const SMART_WIDGET_APPOINTMENT_SOURCE_ID = 7;

export const SUBSCRIPTION_CONSTANTS = {
  SUBSCRIPTION_FREE_TYPE: {
    id: 1,
    name: 'free',
    desc: 'Calenso Free',
  },
  SUBSCRIPTION_FLATRATE_TYPE: {
    id: 5,
    name: 'flatrate',
    desc: 'Calenso Flatrate',
  },
  SUBSCRIPTION_WHITELABEL_TYPE: {
    id: 100,
    name: 'whitelable',
    desc: 'Calenso Whitelable',
  },
  SUBSCRIPTION_ENTERPRISE_TYPE: {
    id: 101,
    name: 'enterprise',
    desc: 'Calenso Enterprise',
  },
  SUBSCRIPTION_PROFESSIONAL_TYPE: {
    id: 102,
    name: 'professional',
    desc: 'Calenso professional',
  },
  SUBSCRIPTION_BASIC_TYPE: {
    id: 103,
    name: 'basic',
    desc: 'Calenso Basic',
  },
  SUBSCRIPTION_BUSINESS_TYPE: {
    id: 104,
    name: 'business',
    desc: 'Calenso Business',
  },
  SUBSCRIPTION_NEW_ENTERPRISE_TYPE: {
    id: 105,
    name: 'newEnterprise',
    desc: 'Calenso New Enterprise',
  },
  // v2 tier set (2026 rollout). IDs match config/Seeds/SubscriptionTypesSeed.php
  // in the CakePHP backend (JB-1029).
  SUBSCRIPTION_V2_BASIC_TYPE: {
    id: 202,
    name: 'basic',
    desc: 'Calenso Basic',
  },
  SUBSCRIPTION_V2_STARTER_TYPE: {
    id: 203,
    name: 'starter',
    desc: 'Calenso Starter',
  },
  SUBSCRIPTION_V2_TEAM_TYPE: {
    id: 204,
    name: 'team',
    desc: 'Calenso Team',
  },
  SUBSCRIPTION_V2_ENTERPRISE_TYPE: {
    id: 205,
    name: 'enterprise',
    desc: 'Calenso Enterprise',
  }
};

export const VAT_TYPE = {
  PLUS: 'plus',
  EXCLUDE: 'exclude'
};

export const CAPTCHA_TYPE = {
  CALENSO_DEFAULT: 'calenso_default',
  FRIENDLY: 'friendly'
} as const;

export const DEFAULT_TIMEZONE = 'Europe/Zurich';

export const WIDGET_DISPLAY_TIMEZONE_SOURCE = {
  VISITOR: 'visitor',
  PARTNER: 'partner',
} as const;
export type WidgetDisplayTimezoneSource =
  typeof WIDGET_DISPLAY_TIMEZONE_SOURCE[keyof typeof WIDGET_DISPLAY_TIMEZONE_SOURCE];

/**
 * Stable machine-readable codes the backend returns in errors[0].error_code.
 * Matched instead of the message, which is localized and may change.
 */
export const SMART_WIDGET_ERROR_CODES = {
  PARTNER_BLOCKED: 'partner_blocked',
  BOOKING_WIDGET_DISABLED: 'booking_widget_disabled',
} as const;
